import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/services/productservice';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-island-details',
  templateUrl: './island-details.component.html',
  styleUrls: ['./island-details.component.scss'],
})
export class IslandDetailsComponent implements OnInit {
  selectedIslandName: any;
  islandType: any;
  islandsBannerAndContent: any;
  responsiveOptions: { breakpoint: string; numVisible: number; numScroll: number }[];
  islandsImageGallery: any;
  view_node: any;
  islandsDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  bannerImage: string;
  images: any = [];
  activeIndex: any;
  displayCustom: boolean;
  constructor(private route: ActivatedRoute, private productService: ProductService, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.view_node = params['view_node'];
      // this.islandType = params['islandType'];
      this.getDetails();
    });
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
  getDetails() {
    this.productService.getIslandDetails(this.view_node).then((innerIslands) => {
      this.islandsDetails = innerIslands;
      if (this.islandsDetails.bannerImage) {
        this.bannerImage = this.islandsDetails.bannerImage;
      } else {
        this.bannerImage = '../../../assets/images/NoImage.jpg';
      }
      this.images.push(this.bannerImage);
    });

    if (this.islandType == 'Inner Islands') {
      this.productService.getinnerIslandsBannerAndContent().then((innerIslands) => {
        this.islandsBannerAndContent = innerIslands;
      });
      // this.productService.getIslandDetailsImageGallery().then((innerIslands) => {
      //   this.islandsImageGallery = innerIslands;
      // });
    } else if (this.islandType == 'Outer Islands') {
      this.productService.getouterIslandsBannerAndContent().then((outerIslands) => {
        this.islandsBannerAndContent = outerIslands;
      });
      // this.productService.getIslandDetailsImageGallery().then((outerIslands) => {
      //   this.islandsImageGallery = outerIslands;
      // });
    }
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
